import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Flex,
  Heading,
  Box,
  Button,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Input,
  IconButton,
} from '@chakra-ui/react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb';
import TabelaBibliotecaMidiaDigitalProps from './tabelaBibliotecaMidiaDigital';
import Paginacao from '../../../components/common/paginacao/paginacao';
import * as api from '../../../api/midiaDigital';
import { AiOutlineClose, AiOutlineSearch } from 'react-icons/ai';

const GerenciarBibliotecaMidiaDigital = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [midias, setMidias] = useState<any[]>([]);

  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPages, setTotalPages] = useState(10);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [pesquisa, setPesquisa] = useState<string>('');
  const [tiposMidia, setTiposMidia] = useState<any[]>([]);
  const [codMidiaSelecionado, setCodMidiaSelecionado] = useState<number | undefined>(undefined);

  useEffect(() => {
    const fetchTiposMidia = async () => {
      try {
        const data = await api.listarTipoDeMidia();
        setTiposMidia(data || []);
      } catch (err) {
        console.error('Erro ao buscar tipos de mídia:', err);
      }
    };
    fetchTiposMidia();
  }, []);

  useEffect(() => {
    const fetchMidias = async () => {
      setLoading(true);
      try {
        const data = await api.listarMidias(
          paginaAtual,
          itemsPerPage,
          pesquisa || undefined,
          codMidiaSelecionado,
        );
  
        const lista = Array.isArray(data.dados)
          ? data.dados.map((n: any) => ({
              dscMidia: n.dscMidia ?? '',
              dscDescricao: n.dscDescricao ?? '',
              datRegistro: n.datRegistro ?? '',
              seqMidia: n.seqMidia ?? '',
              dscUriCdn: n.dscUriCdn ?? '',
              numRegistro: n.numRegistro ?? '',
              tipoMidia: n.tipoMidia ?? '',
            }))
          : [];
  
        setMidias(lista);
        setTotalPages(data.totalPaginas ?? 1);
      } catch (err) {
        console.error('Erro ao buscar mídias:', err);
        setMidias([]);
      } finally {
        setLoading(false);
      }
    };
  
    fetchMidias();
  }, [paginaAtual, itemsPerPage, pesquisa, codMidiaSelecionado]);  

  useEffect(() => {
    setPaginaAtual(1);
  }, [pesquisa, codMidiaSelecionado]);

  const handleDeleteMidia = (seqMidiaDeletada: number) => {
    setMidias((prevMidias) =>
      prevMidias.filter((midia) => midia.seqMidia !== seqMidiaDeletada)
    );
  };  

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Biblioteca de Mídias Digitais
      </Heading>

      <Flex
        w="100%"
        mt="40px"
        mb="20px"
        align="flex-start"
        justify="space-between"
        flexWrap="wrap"
        gap="16px"
      >
        <Button
          color="#fff"
          bgColor="#1789FC"
          _hover={{
            bgColor: "#1468C9"
          }}
          onClick={() => navigate('inserir-midia')}
        >
          Nova Mídia
        </Button>

        <Box flex="1" minW="280px">
          <InputGroup mb="12px">
            <InputLeftElement pointerEvents="none">
              <AiOutlineSearch color="#6e6e6e" />
            </InputLeftElement>
            <Input
              bg="white"
              placeholder="Pesquisar por título..."
              value={pesquisa}
              onChange={e => setPesquisa(e.target.value)}
            />
            {pesquisa && (
              <InputRightElement>
                <IconButton
                  size="sm"
                  variant="ghost"
                  aria-label="Limpar busca"
                  icon={<AiOutlineClose />}
                  onClick={() => setPesquisa('')}
                />
              </InputRightElement>
            )}
          </InputGroup>

          <Flex wrap="wrap" gap="12px" justifyContent="flex-end">
            <DropdownButton
              id="dropdown-tipo-midia"
              size="sm"
              title={
                codMidiaSelecionado
                  ? tiposMidia.find(t => t.codMidia === codMidiaSelecionado)?.dscMidia
                  : "Tipo de mídia"
              }
              className="custom-dropdown"
            >
              {tiposMidia.map(tipo => (
                <Dropdown.Item
                  key={tipo.codMidia}
                  onClick={() => setCodMidiaSelecionado(tipo.codMidia)}
                >
                  {tipo.dscMidia}
                </Dropdown.Item>
              ))}
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => setCodMidiaSelecionado(undefined)}>
                Limpar filtro
              </Dropdown.Item>
            </DropdownButton>
          </Flex>
        </Box>
      </Flex>

      <Box position="relative" mt={5}>
        <TabelaBibliotecaMidiaDigitalProps 
          listaBibliotecaMidiaDigital={midias} 
          listaVazia="Nenhum dado disponível." 
          loading={loading}
          onDelete={handleDeleteMidia}
        />
      </Box>

      <Paginacao 
        paginaAtual={paginaAtual} 
        totalPages={totalPages} 
        onPageChange={setPaginaAtual}
      />
    </Flex>
  );
};

export default GerenciarBibliotecaMidiaDigital;
